var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c("app-reminder-layout-editor", {
        attrs: { layout: _vm.layout },
        on: {
          save: function ($event) {
            return _vm.save()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }